export enum Roles {
    Requestor = "Requestor",
    NewFieldsApprover = "NewFieldsApprover",
    GreenApprover = "GreenApprover",
    OrangeApprover = "OrangeApprover",
    RedApprover = "RedApprover",
    AadAdmin = "AadAdmin",
    Administrator = "Administrator",
}
